module.exports = __webpack_public_path__ + "media/images/sgs_iso_27001-7831134b12cda2716a20411bc8b20872.svg";